import { useQuery } from '@tanstack/react-query'
import { topologyApi } from '@/api/topology'
import { useCurrentTenant } from '@/store/auth'

export function useTopologyData() {
  const tenant = useCurrentTenant()

  const topology = useQuery({
    queryKey: ['infra-topology', tenant?.id],
    queryFn: () => topologyApi.getTopology(tenant!.id),
    enabled: !!tenant?.id,
    staleTime: 300_000,
  })

  const incidents = useQuery({
    queryKey: ['infra-incidents', tenant?.id],
    queryFn: () => topologyApi.getIncidents(tenant!.id),
    enabled: !!tenant?.id,
    staleTime: 300_000,
  })

  const incidentsToday = useQuery({
    queryKey: ['infra-incidents-today', tenant?.id],
    queryFn: () => topologyApi.getIncidents(tenant!.id, 1),
    enabled: !!tenant?.id,
    staleTime: 300_000,
  })

  return { topology, incidents, incidentsToday, tenant }
}
